module.exports = __webpack_public_path__ + "img/logox.2bc4bafe.png";